import type { CompanyTenantsData } from '../store/api/tenants/tenantsApi';

export interface System {
  loggerOptions: {
    loggerCallback: any;
  };
}
export interface Cache {
  cacheLocation: string;
  storeAuthStateInCookie: boolean;
}
export interface Auth {
  clientId: string;
  authority: string;
  audience: string;
  redirectUri: string;
  postLogoutRedirectURi: string;
  clientSecret: string;
}

export interface Config {
  [key: string]: {
    auth: Auth;
    cache: Cache;
    system: System;
  };
}
export interface Configs {
  configs: Config;
}

// Função para converter CompanyTenantsResponse[] em Config
export const buildTenantConfigs = (tenants: CompanyTenantsData[]): Config => {
  const configs: Config = {};

  tenants.forEach((tenant) => {
    if (!tenant.companyName || !tenant.audienceId || !tenant.tenants) {
      console.warn(`Tenant inválido ignorado:`, tenant);
      return;
    }

    configs[tenant.companyName] = {
      auth: {
        clientId: tenant.audienceId,
        authority: `https://login.microsoftonline.com/${tenant.tenants}/oauth2/v2.0/token`,
        audience: tenant.audienceId,
        redirectUri: '/signin-oidc',
        postLogoutRedirectURi: '/',
        clientSecret: '',
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
      system: {
        loggerOptions: {
          // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
          loggerCallback: (level: any, message: any, containsPii: any) => {
            if (containsPii) {
              return;
            }
          },
        },
      },
    };
  });

  return configs;
};

// TenantConfigs agora é gerado dinamicamente a partir da API
// Mantido apenas para compatibilidade com código legado
export const TenantConfigs: Configs = {
  configs: {},
};
